import { cn } from '@/lib/utils';
import { LayoutGrid } from 'lucide-react';

interface AppInfo {
    elementId: string;
    toolName?: string;
    title?: string;
}

interface DMInteractiveAppsProps {
    apps: AppInfo[];
}

const DMInteractiveApps = ({ apps }: DMInteractiveAppsProps) => {
    if (!apps.length) return null;

    const handleClick = () => {
        window.dispatchEvent(
            new CustomEvent('openAppsSidebar', {
                detail: { elementIds: apps.map((a) => a.elementId) }
            })
        );
    };

    const title =
        apps.length === 1
            ? apps[0].title ?? apps[0].toolName ?? 'Chart'
            : `${apps.length} Charts`;

    const subtitle =
        apps.length === 1
            ? 'Chart'
            : apps.map((a) => a.title ?? a.toolName ?? 'Chart').join(', ');

    return (
        <button
            onClick={handleClick}
            className={cn(
                'relative flex items-center w-full overflow-clip',
                'bg-background border border-border rounded-lg p-4',
                'hover:bg-muted/20 transition-colors cursor-pointer',
                'text-left group'
            )}
        >
            <div className="flex flex-col grow min-w-0">
                <span className="font-medium text-foreground text-base truncate leading-6">
                    {title}
                </span>
                <span className="max-w-[60%] text-muted-foreground text-sm truncate leading-5">
                    {subtitle}
                </span>
            </div>
            <div
                className={cn(
                    'top-4 right-16 absolute flex justify-center items-center',
                    'bg-background border border-foreground/20 dark:border-border rounded-lg p-4 pb-16',
                    'rotate-11 transition-transform duration-200 ease-linear',
                    'group-hover:rotate-6',
                    'group-hover:scale-105'
                )}
            >
                <LayoutGrid className="w-6 h-6 text-muted-foreground" />
            </div>
        </button>
    );
};

export default DMInteractiveApps;
